import { render, staticRenderFns } from "./NavigationPills.vue?vue&type=template&id=15f8f8b7&scoped=true"
import script from "./NavigationPills.vue?vue&type=script&lang=js"
export * from "./NavigationPills.vue?vue&type=script&lang=js"
import style0 from "./NavigationPills.vue?vue&type=style&index=0&id=15f8f8b7&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f8f8b7",
  null
  
)

export default component.exports